import axios from "axios";

export const LOGIN = "admin/auth/login";
export const REFRESH_TOKEN = "admin/auth/refresh-token";
export const LIST_USER = "admin/info/list-user";
export const LIST_USER_EXCEL = "admin/info/list-user/export-excel";
export const LIST_ADMIN = "admin/info/list";
export const REGISTER = "admin/auth/register";
export const LOCK_USER = "admin/auth/lock-user";
export const LOCK_ADMIN = "admin/auth/lock";
export const UNLOCK_USER = "admin/auth/unlock-user";
export const UNLOCK_ADMIN = "admin/auth/unlock";
export const CONVERSION_HIS = "admin/info/exchange-history";
export const CONVERSION_HIS_EXCEL = "admin/info/exchange-history/export-excel";
export const PLAY_HIS = "admin/info/current-turns";
export const PLAY_HIS_EXCEL = "admin/info/current-turns/export-excel";
export const GAMING_HIS = "admin/info/mid-autumn-history";
export const GAMING_HIS_EXCEL = "admin/info/mid-autumn-history/export-excel";
export const CONFIG = "admin/info/mid-autumn-config";
export const UPDATE_CONFIG = "admin/info/mid-autumn-config/bulk";
export const UPDATE_WORD_BONUS = "admin/info/mid-autumn-config/word-bonus-scores";
export const UPDATE_LETTER_RATES = "admin/info/mid-autumn-config/letter-rates";
export const UPDATE_JADE_BOX = "admin/info/mid-autumn-config/jade-box-rate";
export const UPDATE_TURN_USER = "admin/info/update-user-turns";
export const LIST_RANK = "admin/info/mid-autumn/played-users";
export const UPDATE_USER_FAKE = "admin/info/mid-autumn/fake-users";
export const LIST_REWARD_CLAIM = "admin/info/mid-autumn/reward-claims";
export const ADD_USER_FAKE = "admin/info/pop-up/add-user-fake";
export const LIST_USER_FAKE = "admin/info/pop-up/add-user-fake";

// Dashboard statistics
export const DAILY_PARTICIPANTS = "admin/info/mid-autumn/daily-participants";
export const VIP_USER_COUNTS = "admin/info/mid-autumn/vip-user-counts";
export const VIP_TOTAL_SCORES = "admin/info/mid-autumn/vip-total-scores";
export const SUMMARY_STATS = "admin/info/mid-autumn/summary-stats";
export const DEPOSIT_STATS = "admin/info/deposit-stats";
export const TOTAL_SCORE_STATS = "admin/info/mid-autumn/total-score-stats";

//--------------
const baseURL = "https://dt68-api-trungthu.tlj129.com/api/v1";

const API = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

const auth = localStorage.getItem("auth");
if (auth) {
  API.defaults.headers.common["Authorization"] =
    JSON.parse(auth).tokenType + " " + JSON.parse(auth).accessToken;

  API.interceptors.response.use(undefined, (err) => {
    const error = err.response;
    // if error is 401
    if (error.status === 401 || error.status === 403) {
      refreshToken(JSON.parse(auth).refreshToken)
    } else {
      return Promise.reject(error);
    }
  });
}

const refreshToken = async (refreshToken) => {
  const params = {
    refreshToken: refreshToken
  };

  await API.post(REFRESH_TOKEN, params)
    .then((response) => {
      if (response.data) {
        const data = response?.data.data;
        const dataAuth = {
          tokenType: "Bearer",
          accessToken: data?.token,
          refreshToken: data?.refreshToken,
          username: data?.username,
          role: data?.role,
        };
        localStorage.setItem("auth", JSON.stringify(dataAuth));
        window.location.reload();
      } else {
        localStorage.clear();
        window.location.assign("/login");
      }
    })
    .catch((error) => {
      console.log(error);
      localStorage.clear();
      window.location.assign("/login");
    });
};

export default API;
